import React from "react";

import {
  Chip,
  Stack,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";

import {
  Meeting,
} from "../../../types";
import {
  getMeetingStatus,
} from "../../../types-helpers";
import { theme } from "../../../theme";

import JoinMeetingButton from "../common/join-meeting-button";

interface MeetingStatusDisplayProps {
  meeting: Meeting;
  showEdit: boolean;
  onEdit: () => void;
  onCancelMeeting: () => void;
}

const MeetingStatusDisplay: React.FC<MeetingStatusDisplayProps> = ({
  meeting,
  showEdit,
  onEdit,
  onCancelMeeting,
}) => {
  const [isConfirmingCancel, setIsConfirmingCancel] = React.useState(false);
  const { canJoin, message, status } = getMeetingStatus(meeting);
  const meetingStatus = meeting.meetingType ?? status;

  if (canJoin) {
    return (
      <Stack spacing={1} alignItems="center">
        <JoinMeetingButton
          meetingId={meeting.meetingId}
        />
        {message && message !== "Can join the meeting" && (  // todo just dont produce this message in the first place?
          <Typography variant="caption" color="textSecondary">
            {message}
          </Typography>
        )}
      </Stack>
    );
  }

  return (
    <Stack
      alignItems={"center"}
      justifyContent={"center"}
      spacing={1}
      sx={{
        borderRadius: ".5rem",
        paddingY: "1.75rem",
        paddingX: "1rem",
        backgroundColor: theme.palette.meetingStatus[meetingStatus]?.background ?? "#dbeafe6e",
      }}
    >
      <Typography variant={"body1"}>{message}</Typography>
      {showEdit && (
        <Stack direction="row" spacing={1} alignItems="center" justifyContent="center">
          {isConfirmingCancel ? (
            <>
              <Typography variant="caption" color="text.secondary" fontSize={"0.75em"}>
                Are you sure you want to cancel?
              </Typography>
              <Chip
                variant="outlined"
                size="small"
                color="error"
                label="Yes"
                onClick={onCancelMeeting}
                clickable
                sx={{
                  '& .MuiChip-label': { fontSize: '0.75rem' },
                }}
              />
              <Chip
                variant="outlined"
                size="small"
                label="No"
                onClick={() => setIsConfirmingCancel(false)}
                clickable
                sx={{
                  '& .MuiChip-label': { fontSize: '0.75rem' },
                }}
              />
            </>
          ) : (
            <>
              <Chip
                variant="outlined"
                size="small"
                color="primary"
                icon={<EditIcon />}
                label="Edit Meeting"
                onClick={onEdit}
                clickable
                sx={{
                  '& .MuiChip-label': { fontSize: '0.75rem', mr: 0.6 },
                  '& .MuiChip-icon': { fontSize: '0.75rem', ml: 1 }
                }}
              />
              <Chip
                variant="outlined"
                size="small"
                color="error"
                icon={<CloseIcon />}
                label="Cancel Meeting"
                onClick={() => setIsConfirmingCancel(true)}
                clickable
                sx={{
                  '& .MuiChip-label': { fontSize: '0.75rem', mr: 0.6 },
                  '& .MuiChip-icon': { fontSize: '0.75rem', ml: 1 }
                }}
              />
            </>
          )}
        </Stack>
      )}
    </Stack>
  );
};

export default MeetingStatusDisplay;
